import { Row, Tooltip } from 'antd';
import { FilePdfFilled, VideoCameraFilled } from '@ant-design/icons';
import { HTMLAttributeAnchorTarget } from 'react';
import './home.css';
import { Link } from 'react-router-dom';
import { Transform } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import AppContext, { AppContextProps } from '../components/infrastructure/appContext';
import { BaseComponent, IBaseProps, IBaseStates } from '../components/infrastructure/baseComponent';
import { isMobile } from 'react-device-detect';


const AparatIcon = (props: { width: string; height: string; }) => {
    return (

        <svg viewBox="0 0 69 69" width={props.width} height={props.height} style={{ color: 'darkslategrey' }}>
            <g>
                <path d="M29.81,2.39 L23.51,0.72 C17.862943,-0.77904572 12.06978,2.58313791 10.57,8.23 L9,14.16 C14.182586,7.72726376 21.626533,3.51701609 29.81,2.39 Z" id="Path"></path>
                <path d="M2.22,39.69 L0.68,45.49 C-0.819046,51.137057 2.543138,56.9302203 8.19,58.43 L14.19,60.03 C7.785492,54.9953325 3.511889,47.7334212 2.22,39.69 Z" id="Path"></path>
                <path d="M60.78,10.61 L54,8.82 C60.869123,14.1038778 65.335137,21.9194019 66.4,30.52 L68.25,23.52 C69.73264,17.89483 66.395762,12.1278836 60.78,10.61 Z" id="Path"></path>
                <path d="M39,66.62 L45.45,68.33 C51.097057,69.8290457 56.89022,66.4668621 58.39,60.82 L60.21,53.98 C55.083976,60.8260117 47.460467,65.3692061 39,66.62 Z" id="Path"></path>
                <path d="M34.49,4.9 C22.505784,4.9 11.70161,12.1191177 7.115449,23.1910899 C2.529288,34.2630621 5.064305,47.0074533 13.538426,55.4815739 C22.012547,63.9556945 34.756938,66.4907116 45.82891,61.9045505 C56.900882,57.3183895 64.12,46.5142163 64.12,34.53 C64.12,18.1658029 50.854197,4.9 34.49,4.9 Z M17.71,19.68 C18.594678,15.092887 23.029988,12.0911064 27.617284,12.9748333 C32.20458,13.8585603 35.20728,18.293248 34.324504,22.8807273 C33.441727,27.4682066 29.007662,30.4718254 24.42,29.59 C22.215709,29.1662984 20.270158,27.8839602 19.011669,26.0252975 C17.75318,24.1666348 17.284928,21.8840271 17.71,19.68 Z M30,45.28 C29.115322,49.867113 24.680012,52.8688936 20.092716,51.9851667 C15.50542,51.1014397 12.50272,46.666752 13.385496,42.0792727 C14.268273,37.4917934 18.702338,34.4881746 23.29,35.37 C25.494291,35.7937016 27.439842,37.0760398 28.698331,38.9347025 C29.95682,40.7933652 30.425072,43.0759729 30,45.28 Z M33.59,38.43 C31.554147,38.0361572 30.221447,36.0684756 30.611139,34.0318239 C31.000831,31.9951723 32.965792,30.658464 35.003234,31.0440041 C37.040676,31.4295442 38.381386,33.3917767 38,35.43 C37.616059,37.4706248 35.650667,38.8137173 33.61,38.43 L33.59,38.43 Z M51.24,49.37 C50.355322,53.957113 45.920012,56.9588936 41.332716,56.0751667 C36.74542,55.1914397 33.74272,50.756752 34.625496,46.1692727 C35.508273,41.5817934 39.942338,38.5781746 44.53,39.46 C46.737973,39.8790968 48.688453,41.1595088 49.951057,43.0187072 C51.213661,44.8779055 51.684614,47.1630814 51.26,49.37 L51.24,49.37 Z M45.64,33.69 C41.052887,32.8053224 38.051106,28.3700124 38.934833,23.7827162 C39.81856,19.1954199 44.253248,16.1927201 48.840727,17.0754963 C53.428207,17.9582725 56.431825,22.3923378 55.55,26.98 C54.662614,31.5569205 50.239633,34.5532777 45.66,33.68 L45.64,33.69 Z" id="Shape"></path>
            </g>
        </svg >
    );
}

const FaqIcon = (props: { width: string; height: string; }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 122.88 116.17"
            transform="matrix(-1,0,0,1,0,0)"
            {...props}
        >
            <defs>
                <style>{".cls-1{fill-rule:evenodd;}"}</style>
            </defs>
            <path
                fill="#F0C51E"
                className="cls-1"
                d="M94.5,20.23,83.39,17.3,96.2,0l11.93,2L99.75,11l12.8,3.6L85.15,37.71,94.5,20.23Zm-61,27.86a20.49,20.49,0,0,1,.41-5,6.85,6.85,0,0,1,3.27-4.28c.69-.45,1.3-.89,1.84-1.31a5.75,5.75,0,0,0,1.29-1.33,2.88,2.88,0,0,0,.09-3C38.91,30.68,34.7,31.87,34.7,35H26.44a9.79,9.79,0,0,1,1.61-5.76A9.27,9.27,0,0,1,32.25,26a15.46,15.46,0,0,1,5.74-1,17.65,17.65,0,0,1,6.16,1,9.42,9.42,0,0,1,4.28,3A8.07,8.07,0,0,1,50,34a7.82,7.82,0,0,1-2.52,6,14.74,14.74,0,0,1-2.76,2,7.08,7.08,0,0,0-3.15,3,7.05,7.05,0,0,0-.41,3Zm33.33-5h4.42V22.84a7.61,7.61,0,0,0-7.6-7.6H12.74a7.61,7.61,0,0,0-7.6,7.6V59.75a7.61,7.61,0,0,0,7.6,7.6h13.5A1.94,1.94,0,0,1,28,69.42L29,78,44.21,67.91a2,2,0,0,1,1.36-.56h6.88V55.84a12.71,12.71,0,0,1,3.75-9h0a12.8,12.8,0,0,1,9-3.74Zm9.56,0h33.71a12.78,12.78,0,0,1,12.74,12.74V92.75a12.71,12.71,0,0,1-3.75,9h0a12.94,12.94,0,0,1-8.33,3.73l-.68,6.12a5.13,5.13,0,0,1-8.06,3.63l-14.63-9.74H65.19a12.8,12.8,0,0,1-9-3.74l-.34-.36a12.92,12.92,0,0,1-2.42-3.77,12.68,12.68,0,0,1-1-4.87V72.49H46.59L32,82.23a5.08,5.08,0,0,1-2.4.91,5.14,5.14,0,0,1-5.66-4.54l-.68-6.12H12.74v0a12.85,12.85,0,0,1-9-3.74h0a12.71,12.71,0,0,1-3.75-9V22.84A12.79,12.79,0,0,1,12.74,10.1H63.69a12.8,12.8,0,0,1,9,3.74h0a12.71,12.71,0,0,1,3.75,9V43.1Zm16,13H82.87V68l1.86,14h5.93l1.79-14V56.1ZM90.58,86.29H84.75v5.38h5.83V86.29ZM37.47,58.93a4.43,4.43,0,0,1-3.2-1.31A4.33,4.33,0,0,1,33,54.42a4.27,4.27,0,0,1,1.32-3.15,4.51,4.51,0,0,1,6.34,0A4.3,4.3,0,0,1,42,54.42a4.49,4.49,0,0,1-.66,2.28,4.94,4.94,0,0,1-1.65,1.63,4.23,4.23,0,0,1-2.22.6Z"
            />
        </svg>
    );
}

interface LinkIconProps {
    name?: string;
    icon: "aparat" | "video" | "pdf" | "faq";
    transformIcon?: Transform;
    to?: string;
    pathname?: string;
    search?: string;
    title?: string;
    target?: HTMLAttributeAnchorTarget;
    tooltip?: string;
    height: number;
    colorClass: string;
}

export const LinkIcon = (props: LinkIconProps) => {
    const [over, setOver] = React.useState<boolean>(false);

    const icon = (icon: "aparat" | "video" | "pdf" | "faq") => {
        switch (icon) {
            case "aparat":
                return <AparatIcon width={'4.5em'} height={'4em'} />
            case "faq":
                return <FaqIcon width={'4.5em'} height={'4em'} />
            case "pdf":
                return <FilePdfFilled className={props.colorClass} style={{ fontSize: 44, color: 'darkslategrey', verticalAlign: 'baseline' }} />
            default:
                return <VideoCameraFilled className={props.colorClass} style={{ fontSize: 48, color: 'darkslategrey', verticalAlign: 'baseline' }} />
        }
    }

    return (
        <Link to={props.to ? props.to : { pathname: props.pathname, search: props.search }}
            target={props.target}
            onMouseOver={() => setOver(true)}
            onMouseLeave={() => setOver(false)}>
            <Tooltip title={props.tooltip}>
                <div className={`btn-big`} style={{ height: props.height, margin: "0 15px 15px 0" }}>
                    <div style={{ marginTop: isMobile || over ? -18 : -5 }}>
                        {icon(props.icon)}
                    </div>
                    <div className="label bottom" style={{ position: "initial", marginTop: isMobile || over ? 0 : -15, marginLeft: 10, marginRight: 10 }}>
                        <span className="title" style={{ display: 'block', fontSize: isMobile || over ? 12 : 14 }} >{props.title}</span>
                    </div>
                </div>
            </Tooltip>
        </Link>
    );
}

interface IHelpProps extends IBaseProps {

}
interface IHelpStates extends IBaseStates {

}
export class Help extends BaseComponent<IHelpProps, IHelpStates>{
    static contextType = AppContext;
    constructor(props: IHelpProps) {
        super(props)

        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.setLoading(false);
    }
    virtualRender() {
        const header = this.getPageHeader({ title: "راهنما", onBack: () => this.props.onClose ? this.props.onClose({}) : window.history.back() });

        const { getUserInfo } = this.context as AppContextProps;
        const userInfo = getUserInfo();
        const isEvaluator = !!userInfo?.extraVariables["EvaluatorId"];
        const isInsurerCenter = !!userInfo?.extraVariables["InsurerCenterId"];

        return (
            <>
                <div style={{ direction: 'rtl' }}>
                    {header}
                </div>
                <div className=" wrapper" style={{ width: "100%", marginTop: 30 }} >
                    <Row className="center" style={{ height: 180, display: 'flex' }}>
                        <LinkIcon to={"/faq"} icon="faq" transformIcon={{ flipX: true }} title="پرسش های متداول" height={150} colorClass="font-lemon" />
                        <LinkIcon pathname="https://www.aparat.com/Zobdeh_EE" icon="aparat" transformIcon={{ flipX: true }} title="کانال شرکت زبده در آپارات" target="_blank" height={150} colorClass="font-orange" />
                        {(isEvaluator || isInsurerCenter) && <LinkIcon to="Attachments/Help/evaluationPolicyholderInPerson.pdf" icon="pdf" transformIcon={{ flipX: true }} title="فایل آموزشی ارزیابی مراجعه حضوری مشتری به مرکز ارزیابی" target="_blank" height={150} colorClass="font-purple-light" />}
                        {!(isEvaluator || isInsurerCenter) && <LinkIcon to="Attachments/Help/createDamageCase.pdf" icon="pdf" transformIcon={{ flipX: true }} title="فایل آموزشی ثبت خسارت تا پایان پرونده توسط مشتری" target="_blank" height={150} colorClass="font-green-light" />}
                        {!(isEvaluator || isInsurerCenter) && <LinkIcon pathname="https://www.aparat.com/v/1GKTd" icon="video" transformIcon={{ flipX: true }} title="فیلم آموزشی ثبت خسارت تجهیزات الکترونیک توسط مشتری" target="_blank" height={150} colorClass="font-blue-light" />}
                        {(isEvaluator || isInsurerCenter) && <LinkIcon pathname="https://www.aparat.com/v/uMG2i" icon="video" transformIcon={{ flipX: true }} title="فیلم آموزشی ارزیابی پرونده خسارت در مراجعه حضوری مشتری به مراکز ارزیابی زبده" target="_blank" height={150} colorClass="font-green-light" />}
                        {(isEvaluator || isInsurerCenter) && <LinkIcon pathname="https://www.aparat.com/v/9t3hi" icon="video" transformIcon={{ flipX: true }} title="فیلم آموزشی ارزیابی پرونده خسارت در ارزیابی تماس تصویری (ویدئوکال) شرکت زبده" target="_blank" height={150} colorClass="font-blue-light" />}
                    </Row>
                </div>
            </>
        );
    }
}
